import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '../features/shared/loader/loader.service';
import { finalize, Observable } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loaderService = inject(LoaderService);
  if (req.url.includes('FindPSWSPerson')) {
    return next(req);
  }
  if (req.url.includes('HeartbeatUserLoginSession') || req.url.includes('EndUserLoginSession') || req.url.includes('StartUserLoginSession')) {
    return next(req);
  }
  loaderService.startLoading();
  return next(req).pipe(finalize(() => loaderService.stopLoading()));
};
